import React from 'react';
import './PrivacyPolicyPage.css';
import Footer from '../../components/Footer/Footer';
import SmartNavigation from '../../components/Navigation/SmartNavigation';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="privacy-policy-page">
      {/* Navigation Header */}
      <SmartNavigation forceVariant="light" />
      
      {/* Privacy Policy Content */}
      <div className="privacy-policy-content">
        <div className="privacy-policy-container">
          <h1>Privacy Policy</h1>
          
          <div className="privacy-policy-text">
            <p className="last-updated">Last updated: January 2025</p>
            
            <section>
              <h2>1. Introduction</h2>
              <p>
                Welcome to Awasi. We are committed to protecting your personal information and your right to privacy. 
                This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you 
                visit our website or stay at our properties.
              </p>
            </section>

            <section>
              <h2>2. Information We Collect</h2>
              <p>
                We collect information that you provide directly to us, such as when you make a reservation, 
                create an account, subscribe to our newsletter, or contact us for support. This may include:
              </p>
              <ul>
                <li>Name and contact information</li>
                <li>Payment and billing information</li>
                <li>Travel preferences and special requests</li>
                <li>Dietary restrictions and health information (when relevant to your stay)</li>
                <li>Communication preferences</li>
              </ul>
            </section>

            <section>
              <h2>3. How We Use Your Information</h2>
              <p>
                We use the information we collect to:
              </p>
              <ul>
                <li>Process your reservations and provide our services</li>
                <li>Communicate with you about your stay</li>
                <li>Send you marketing communications (with your consent)</li>
                <li>Improve our services and develop new offerings</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section>
              <h2>4. Information Sharing</h2>
              <p>
                We do not sell, trade, or rent your personal information to third parties. We may share your 
                information with:
              </p>
              <ul>
                <li>Service providers who assist us in operating our business</li>
                <li>Professional advisors and business partners</li>
                <li>Law enforcement or regulatory authorities when required by law</li>
              </ul>
            </section>

            <section>
              <h2>5. Data Security</h2>
              <p>
                We implement appropriate technical and organizational security measures to protect your personal 
                information against unauthorized access, alteration, disclosure, or destruction.
              </p>
            </section>

            <section>
              <h2>6. Your Rights</h2>
              <p>
                Depending on your location, you may have certain rights regarding your personal information, including:
              </p>
              <ul>
                <li>The right to access your personal information</li>
                <li>The right to correct inaccurate information</li>
                <li>The right to request deletion of your information</li>
                <li>The right to opt-out of marketing communications</li>
                <li>The right to data portability</li>
              </ul>
            </section>

            <section>
              <h2>7. International Transfers</h2>
              <p>
                As we operate properties in multiple countries, your information may be transferred to and processed 
                in countries other than your country of residence. We ensure appropriate safeguards are in place for 
                such transfers.
              </p>
            </section>

            <section>
              <h2>8. Children's Privacy</h2>
              <p>
                Our services are not directed to children under 16, and we do not knowingly collect personal 
                information from children under 16 without parental consent.
              </p>
            </section>

            <section>
              <h2>9. Updates to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting 
                the new Privacy Policy on this page and updating the "Last updated" date.
              </p>
            </section>

            <section>
              <h2>10. Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy or our privacy practices, please contact us at:
              </p>
              <div className="contact-info">
                <p>Awasi</p>
                <p>Email: info@awasi.com</p>
                <p>Phone: +(56-2) 2233-9641</p>
              </div>
            </section>
          </div>
        </div>
      </div>

      {/* Instagram Feed + Footer */}
      <InstagramSection />
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;